import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=2c51fb00"
import script from "./UpdateNotification.vue?vue&type=script&lang=ts"
export * from "./UpdateNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c51fb00')) {
      api.createRecord('2c51fb00', component.options)
    } else {
      api.reload('2c51fb00', component.options)
    }
    module.hot.accept("./UpdateNotification.vue?vue&type=template&id=2c51fb00", function () {
      api.rerender('2c51fb00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/UpdateNotification.vue"
export default component.exports